import React from 'react'
import { BrowserRouter } from 'react-router-dom'

import NotificationsProvider from './providers/NotificationsProvider'
import useAppState from './hooks/useAppState'
import { DayPickerGlobalStyles } from './util/DatePicker'
import ModalLexorInstaller from './layout/ModalLexorInstaller'
import TopBar, { TOPBAR_HEIGHT } from './layout/TopBar'
import { ActivitiesUpdaterProvider } from './providers/ActivitiesUpdaterProvider'
import Toaster from './util/Toaster'
import ApolloProvider from './providers/ApolloProvider'
import ThemeProvider from './providers/ThemeProvider'
import LanguageProvider from './providers/LanguageProvider'
import AppRouterWithState from './AppRouterWithState'
import usePermissions from './hooks/usePermissions'
import AppLoading from './AppLoading'
import AppGlobalStyles from './AppGlobalStyles'
import AppGlobalFontStyles from './AppGlobalFontStyles'
import AppErrorBoundary from './AppErrorBoundary'
import ImpersonationOverlay from './pages/tenant-selection/ImpersonationOverlay'
import PopoverStateProvider from './providers/PopoverStateProvider'

const App = ({ apolloClient, notificationDispatcher, handleInstallClick, handleClosePopup }) => {
    const {
        isLoading,
        isAuthenticated,
        isAuthorized,
        accountState,
        accountStateDetails,
        accountStateCompletion,
        preferredCultureCode,
        currentUser,
        currentTenant,
        showInstallPopup
    } = useAppState()
    const { canReadTimer } = usePermissions()
    return (
        <BrowserRouter>
            <ApolloProvider client={apolloClient}>
                <NotificationsProvider dispatcher={notificationDispatcher}>
                    <ThemeProvider>
                        <LanguageProvider languageCode={preferredCultureCode}>
                            <PopoverStateProvider>
                                <AppGlobalFontStyles />
                                <DayPickerGlobalStyles />
                                <AppGlobalStyles />
                                <Toaster />
                                <ImpersonationOverlay />
                                <AppErrorBoundary>
                                     {showInstallPopup && 
                                        <ModalLexorInstaller 
                                            handleInstallClick={handleInstallClick} 
                                            handleClosePopup={handleClosePopup}
                                        />
                                    }
                                    {isLoading ? (
                                        <AppLoading />
                                    ) : (
                                        <ActivitiesUpdaterProvider>
                                            {isAuthenticated && (
                                                <TopBar
                                                    currentUser={currentUser}
                                                    currentTenant={
                                                        currentTenant
                                                    }
                                                    canReadTimer={canReadTimer}
                                                />
                                            )}
                                            <AppRouterWithState
                                                isLoading={isLoading}
                                                isAuthenticated={
                                                    isAuthenticated
                                                }
                                                isAuthorized={isAuthorized}
                                                accountState={accountState}
                                                accountStateDetails={
                                                    accountStateDetails
                                                }
                                                accountStateCompletion={
                                                    accountStateCompletion
                                                }
                                            />
                                        </ActivitiesUpdaterProvider>
                                    )}
                                </AppErrorBoundary>
                            </PopoverStateProvider>
                        </LanguageProvider>
                    </ThemeProvider>
                </NotificationsProvider>
            </ApolloProvider>
        </BrowserRouter>
    )
}

export default App
